export function remove_tags(html) {
  html = html.replace(/<br\s*[\/]?>/g, " ");
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  html = tmp.textContent || tmp.innerText;
  html = html.replace(/\$br\$/g, "<br>");
  return html;
}